import { withCompController } from '@wix/editor-elements-integrations';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import type {
  IHeaderSectionProps,
  IHeaderSectionStateValues,
} from '../HeaderSection.types';

export default withCompController<
  IHeaderSectionProps,
  IHeaderSectionProps,
  IHeaderSectionProps,
  IHeaderSectionStateValues
>(({ mapperProps, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isHeaderUseMarginsEnabled = isExperimentOpen(
    experiments,
    'specs.odeditor.headerUseMargins',
  );

  return {
    ...mapperProps,
    isHeaderUseMarginsEnabled,
  };
});
